import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ChartFieldValue, ChartFormsState } from 'interfaces/store/chartForms';
import { CalculateFieldNames } from 'utils/constants/fieldNames';

const initialState: ChartFormsState = {
  fields: {
    // Required Info fields
    [CalculateFieldNames.CURRENT_ARR]: null,
    [CalculateFieldNames.ANNUAL_REVENUE]: null,
    [CalculateFieldNames.AVG_DEAL_SIZE]: null,
    [CalculateFieldNames.YOY_ARR]: null,
    [CalculateFieldNames.FCF_MARGIN]: null,
    [CalculateFieldNames.GROSS_MARGIN]: null,
    [CalculateFieldNames.TOTAL_HEADCOUNT]: null,
    [CalculateFieldNames.ARR_PER_FTE]: null,
    [CalculateFieldNames.RULE_OF_40]: null,

    // Growth and Retention fields
    [CalculateFieldNames.NEW_LOGO_VELOCITY]: null,
    [CalculateFieldNames.NEW_LOGO_ARR_OF_GROSS_NEW]: null,
    [CalculateFieldNames.EXPANSION_ARR_OF_GROSS_NEW]: null,
    [CalculateFieldNames.NEW_LOGO_ARR]: null,
    [CalculateFieldNames.EXPANSION_ARR]: null,
    [CalculateFieldNames.QUICK_RATIO]: null,
    [CalculateFieldNames.GROSS_CHURN_ARR]: null,
    [CalculateFieldNames.GROSS_DOLLAR_RETENTION]: null,
    [CalculateFieldNames.NET_DOLLAR_RETENTION]: null,
    [CalculateFieldNames.BOP_ARR]: null,

    // Operational Efficiency fields
    [CalculateFieldNames.CAC_PAYBACK_PERIOD]: null,
    [CalculateFieldNames.NET_MAGIC_NUMBER]: null,
    [CalculateFieldNames.BURN_MULTIPLE]: null,
    [CalculateFieldNames.FCF]: null,
    [CalculateFieldNames.NET_NEW_ARR]: null,
    [CalculateFieldNames.GA_PERCENT_OPEX]: null,
    [CalculateFieldNames.SM_PERCENT_OPEX]: null,
    [CalculateFieldNames.RD_PERCENT_OPEX]: null,
    [CalculateFieldNames.GA_ABSOLUTE_OPEX]: null,
    [CalculateFieldNames.SM_ABSOLUTE_OPEX]: null,
    [CalculateFieldNames.RD_ABSOLUTE_OPEX]: null,

    // Headcount fields
    [CalculateFieldNames.GA_HEADCOUNT]: null,
    [CalculateFieldNames.SM_HEADCOUNT]: null,
    [CalculateFieldNames.RD_HEADCOUNT]: null,
    [CalculateFieldNames.GA_HEADCOUNT_PERCENT]: null,
    [CalculateFieldNames.SM_HEADCOUNT_PERCENT]: null,
    [CalculateFieldNames.RD_HEADCOUNT_PERCENT]: null,
    [CalculateFieldNames.OPEX_PER_FTE]: null,
    [CalculateFieldNames.TOTAL_OPEX]: null,
    [CalculateFieldNames.SM_OPEX]: null
  },
  isRequiredInfoPopupOpen: false
};

const chartFormsSlice = createSlice({
  name: 'chartForms',
  initialState,
  reducers: {
    setChartField: (
      state,
      action: PayloadAction<{
        field: ChartFieldValue;
        value: string | null;
      }>
    ) => {
      state.fields[action.payload.field] = action.payload.value;
    },
    setIsRequiredInfoPopupOpen: (state, action: PayloadAction<boolean>) => {
      state.isRequiredInfoPopupOpen = action.payload;
    },
    resetChartForms: state => {
      Object.assign(state.fields, initialState.fields);
      state.isRequiredInfoPopupOpen = initialState.isRequiredInfoPopupOpen;
    }
  }
});

export const { setChartField, setIsRequiredInfoPopupOpen, resetChartForms } =
  chartFormsSlice.actions;

export default chartFormsSlice.reducer;
